import { IcoUploadDocument } from '@icons';
import React, { useEffect, useState } from 'react';
import { Button, Form, InputGroup, Modal, Spinner } from 'react-bootstrap';
import { UploadChoiceType } from './UploadDataButton';
import { UseMutationResult } from '@tanstack/react-query';

interface UploadChoiceModalProps {
	activeKey: string;
	show: boolean;
	selectedFile: File | undefined;
	setSelectedFile: (file: File | undefined) => void;
	mutation: UseMutationResult<any, Error, { file: File; uploadType?: UploadChoiceType; sal?: string }, unknown>;
}

const UploadChoiceModal: React.FC<UploadChoiceModalProps> = ({ activeKey, show, selectedFile, setSelectedFile, mutation }) => {
	const [selectedOption, setSelectedOption] = useState<UploadChoiceType>();
	const [salValue, setSalValue] = useState<string>('');
	const uploadChoiceItems = [
		{
			key: 'FULL',
			label: 'Caricamento Completo',
			description: 'Usare questo caricamento per sovrascrivere tutti i dati esistenti.',
		},
		{
			key: 'PARTIAL',
			label: 'Caricamento Parziale',
			description: 'Usare questo caricamento se si vuole aggiungere nuovi dati o modificare quelli esistenti.',
		},
	];

	if (activeKey === 'invoices') {
		uploadChoiceItems.push({
			key: 'PARTIAL_DELTA',
			label: 'Caricamento con Delta',
			description: 'Usare questo caricamento se si vuole aggiungere nuovi dati o sommare i esistenti.',
		});
	}

	useEffect(() => {
		if (mutation.isSuccess || mutation.isError) {
			setSelectedFile(undefined);
			setSelectedOption(undefined);
			setSalValue('');
		}
	}, [mutation.isSuccess, mutation.isError, setSelectedFile]);
	const handleReset = () => {
		setSelectedFile(undefined);
		setSelectedOption(undefined);
		setSalValue('');
	};
	return (
		<Modal show={show} onHide={handleReset} centered size="lg" className="midmodal" backdropClassName="midmodal-backdrop">
			<Modal.Header
				style={{
					flexDirection: 'column',
					justifyContent: 'center',
					alignItems: 'center',
					gap: '1rem',
					padding: '1.5rem',
				}}
			>
				<IcoUploadDocument />

				<Modal.Title>
					<h5
						style={{
							fontWeight: 700,
							fontSize: '24px',
							textAlign: 'center',
							marginBottom: 0,
						}}
					>
						Scegli tipo di caricamento
					</h5>
				</Modal.Title>

				<div>
					<p
						style={{
							marginBottom: 0,
							textAlign: 'center',
						}}
					>
						Quale tipo di caricamento vuoi effettuare?
					</p>
				</div>
			</Modal.Header>
			<Modal.Body
				style={{
					padding: '1.5rem',
				}}
			>
				<div className="custom-download_list">
					{uploadChoiceItems.map((item) => (
						<InputGroup
							key={item.key}
							style={{
								display: 'grid',
								gridTemplateColumns: 'auto 1fr',
							}}
						>
							<InputGroup.Radio
								checked={selectedOption === item.key}
								onChange={() => {
									setSelectedOption(item.key as UploadChoiceType);
									// if (item.key !== 'PARTIAL_DELTA') {
									// 	setSalValue('');
									// }
								}}
								aria-label={item.label}
								name="download-options"
								value={item.key}
								style={{
									cursor: 'pointer',
								}}

								// className="col-1"
							/>
							<InputGroup.Text
								// className="col-11"
								style={{
									flexDirection: 'column',
									alignItems: 'flex-start',
									whiteSpace: 'normal',
									textAlign: 'left',
								}}
							>
								<span
									style={{
										fontWeight: 700,
										display: 'block',
									}}
								>
									{item.label}
								</span>
								<span
									style={{
										display: 'block',
									}}
								>
									{item.description}
								</span>
								{/* {item.key === 'PARTIAL_DELTA' ? (
									<Form.Group
										style={{
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'center',
											gap: '1rem',
											width: '100%',
											marginTop: '0.5rem',
										}}
									>
										<Form.Label
											htmlFor="sal-value"
											style={{
												whiteSpace: 'nowrap',
												marginBottom: 0,
												fontWeight: 500,
											}}
										>
											SAL di riferimento
										</Form.Label>

										<Form.Control
											type="text"
											id="sal-value"
											value={salValue}
											onChange={(event) => {
												setSalValue(event.target.value);
											}}
											disabled={selectedOption !== 'PARTIAL_DELTA'}
										/>
									</Form.Group>
								) : null} */}
							</InputGroup.Text>
						</InputGroup>
					))}

					{activeKey === 'invoices' || activeKey === 'timesheets' ? (
						<Form.Group
							style={{
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								gap: '1rem',
								width: '100%',
								marginTop: '0.5rem',
							}}
						>
							<Form.Label
								htmlFor="sal-value"
								style={{
									whiteSpace: 'nowrap',
									marginBottom: 0,
									fontWeight: 500,
								}}
							>
								SAL di riferimento
							</Form.Label>

							<Form.Control
								type="text"
								id="sal-value"
								value={salValue}
								onChange={(event) => {
									setSalValue(event.target.value);
								}}
							/>
						</Form.Group>
					) : null}
				</div>
			</Modal.Body>
			<Modal.Footer
				style={{
					display: 'grid',
					gridTemplateColumns: '1fr 1fr',
				}}
			>
				<Button
					className="btn custom-outline-button"
					style={{
						height: '48px',
					}}
					onClick={handleReset}
				>
					Annulla
				</Button>
				<Button
					disabled={!selectedOption || mutation.isPending}
					className="btn custom-primary-button"
					style={{
						height: '48px',
						display: 'flex',
						alignItems: 'center',
						gap: '0.5rem',
						justifyContent: 'center',
					}}
					onClick={() => {
						mutation.mutate({
							file: selectedFile,
							uploadType: selectedOption,
							sal: salValue || undefined,
						});
					}}
				>
					{!mutation.isPending ? (
						'Carica'
					) : (
						<>
							<Spinner animation="border" size="sm" role="status" /> Upload in corso...
						</>
					)}
				</Button>
			</Modal.Footer>
		</Modal>
	);
};

export default UploadChoiceModal;
